var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSettingsIco(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 21,
    viewBox: "0 0 20 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10 14.3262C12.0711 14.3262 13.75 12.6472 13.75 10.5762C13.75 8.5051 12.0711 6.82617 10 6.82617C7.92893 6.82617 6.25 8.5051 6.25 10.5762C6.25 12.6472 7.92893 14.3262 10 14.3262Z",
    stroke: "#969992",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M15.422 6.88086C15.61 7.15013 15.7747 7.43503 15.9141 7.73242L17.9376 8.85742C18.1902 9.98904 18.1929 11.1622 17.9454 12.2949L15.9141 13.4199C15.7747 13.7173 15.61 14.0022 15.422 14.2715L15.461 16.5918C14.6035 17.3732 13.5885 17.962 12.4845 18.3184L10.4923 17.123C10.1646 17.1465 9.8356 17.1465 9.5079 17.123L7.52352 18.3105C6.41595 17.9606 5.39766 17.3742 4.53915 16.5918L4.57821 14.2793C4.3917 14.0063 4.22712 13.7189 4.08602 13.4199L2.06258 12.2949C1.80993 11.1633 1.80726 9.99018 2.05477 8.85742L4.08602 7.73242C4.22546 7.43503 4.39013 7.15013 4.57821 6.88086L4.53915 4.56055C5.39669 3.77911 6.41163 3.19039 7.51571 2.83398L9.5079 4.0293C9.8356 4.00586 10.1646 4.00586 10.4923 4.0293L12.4766 2.8418C13.5842 3.19172 14.6025 3.77817 15.461 4.56055L15.422 6.88086Z",
    stroke: "#969992",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSettingsIco);
export default __webpack_public_path__ + "static/media/settings_ico.763a43061a600d0beb7806d6fb3787e9.svg";
export { ForwardRef as ReactComponent };